(() => {
  if (window.zbEditorialReady) return;
  window.zbEditorialReady = true;
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-zb3-prev],[data-zb3-next]');
    if (!button) return;
    const rail = button.closest('.zb3-edit')?.querySelector('[data-zb3-rail]');
    if (!rail) return;
    rail.scrollBy({left: rail.clientWidth * .85 * (button.hasAttribute('data-zb3-prev') ? -1 : 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
  });
})();
